import React, { useEffect, useRef, useState } from "react";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import i18n from "utils/i18n";
import FooterBar from 'components/organisms/FooterBar'
import EmployeeValues from '../_functions/Employee'
import HelperEmployee from 'utils/HelperEmployee'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { FooterStyles } from 'styles/components/organisms/Footer'
import FormSubmitButton from 'components/atoms/FormSubmitButton'
import { FormStatus } from 'utils/constants/form-constants';
import WorkdaysTab from 'scenes/home/more/workdays/_tabs/workdays'
import LoadingComponent from 'components/atoms/Loading'
import { TESTID } from '_shared/config/testID'


const HomeMoreWorkdaysScene = () => {
	
	const layoutRef = useRef()
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	const [ loading, setLoading ] = useState( true );
	const [ formStatus, setFormStatus ] = useState( FormStatus.NONE )
	
	useEffect( () => {
		EmployeeValues.resetEmployee()
		setLoading( false )
	}, [] );
	
	const submitForm = () => {
		EmployeeValues.submitEmployee( setFormStatus );
	}
	
	const submitButton = (
		<FormSubmitButton
			onPress={ submitForm }
			formStatus={ formStatus }
			formStatusCallback={ setFormStatus }
			style={ [ FooterStyles.button, FooterStyles.buttonFill ] }
			testID={ TESTID.HOME.MORE.WORKDAYS.SUBMIT_BUTTON }>
			
			{ i18n.t( 'buttons.save' ) }
		</FormSubmitButton>
	);
	
	let content = <LoadingComponent />
	let footer = null;
	
	if( !loading ) {
		content = (
			<WorkdaysTab />
		)
		
		footer = (
			<FooterBar
				buttons={ submitButton }
				onHeightCallback={ layoutRef.current?.setFooterHeight }
			/>
		);
	}
	
	const errors = HelperEmployee.isValid( _employee );
	
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				ref={ layoutRef }
				topNavigation={ true }
				showBackButton={ errors.length === 0 }
				footerBar={ footer !== null }
				title={ i18n.t( 'titles.more_workdays') }
				testID={ TESTID.HOME.MORE.SCREENS.WORKDAYS }>
				
				{ content }
			</ThemedLayout>
			
			{ footer }
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeMoreWorkdaysScene;
